import React, { useState } from 'react';
import { Briefcase, Inbox, TrendingUp, Sparkles } from 'lucide-react';
import VacanciesPage from './VacanciesPage';
import VacancyApplicationsPage from './VacancyApplicationsPage';
import VacancyAnalyticsPage from './VacancyAnalyticsPage';
import HubShell from '../../components/staff/HubShell';

/**
 * Recruitment Hub — bundles Analytics, Vacancies, Applications & Talent Pool
 * into a single admin surface so recruiters aren't jumping between sidebar items.
 */
const RecruitmentHubPage = (props) => {
  const isExec = props.currentUser?.role === 'executive' || props.currentUser?.role === 'superadmin';
  const [tab, setTab] = useState(isExec ? 'analytics' : 'vacancies');

  const tabs = [
    { id: 'analytics',    label: 'Overview',        icon: TrendingUp, desc: 'Funnel, per-role stats & time-to-hire', visible: isExec, testId: 'hub-tab-analytics' },
    { id: 'vacancies',    label: 'Open Vacancies',  icon: Briefcase,  desc: 'Publish and manage job openings',       visible: true,   testId: 'hub-tab-vacancies' },
    { id: 'applications', label: 'Applications',    icon: Inbox,      desc: 'Review candidates',                     visible: isExec, testId: 'hub-tab-applications' },
    { id: 'talent-pool',  label: 'Talent Pool',     icon: Sparkles,   desc: 'Saved candidates for future roles',     visible: isExec, testId: 'hub-tab-talent-pool' },
  ];

  return (
    <HubShell
      title="Recruitment"
      accent="Hub"
      subtitle="Post roles, review candidates, and hire — all from one place."
      icon={Briefcase}
      tone="emerald"
      tabs={tabs}
      activeTab={tab}
      onTabChange={setTab}
      dataTestId="recruitment-hub"
    >
      {tab === 'analytics'    && isExec && <VacancyAnalyticsPage {...props} />}
      {tab === 'vacancies'    && <VacanciesPage {...props} />}
      {tab === 'applications' && isExec && <VacancyApplicationsPage {...props} />}
      {tab === 'talent-pool'  && isExec && <VacancyApplicationsPage {...props} initialPool="only" key="talent-pool" />}
    </HubShell>
  );
};

export default RecruitmentHubPage;
